import { useCallback, useEffect, useState } from "react";
import { Select, Space, Tag } from "antd";
import { getValueFromNestedObject } from "@/Utils/Index";

const MultiSelect = (props) => {
  const {
    options,
    form: { values, setFieldValue },
    field: { name, hasRemoveIndex },
  } = props;

  const value = getValueFromNestedObject(values, name);
  const [selectedOptions, setSelectedOptions] = useState(value || []);
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [removeIndex, setRemoveIndex] = useState();

  const updateText = useCallback((value) => {
    setInputValue(value);
    const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(value.toLowerCase()));
    setFilteredOptions(filteredOptions);
  }, []);

  useEffect(() => {
    setFieldValue(name, selectedOptions);
    let data;
    if (hasRemoveIndex) {
      data = {
        selectedOptions: selectedOptions,
        removeIndex: removeIndex,
      };
    } else {
      data = selectedOptions;
    }
    props.onChange && props.onChange(data, props.form);
  }, [selectedOptions, removeIndex]);

  const removeTag = useCallback(
    (tag, index) => () => {
      const newSelectedOptions = selectedOptions.filter((option) => option.value !== tag);
      setSelectedOptions(newSelectedOptions);
      setRemoveIndex(index);
    },
    [selectedOptions, removeIndex]
  );

  const verticalContentMarkup =
    selectedOptions.length > 0 ? (
      <Space size="small" wrap style={{ marginTop: "8px" }}>
        {selectedOptions.map((option, index) => {
          let tagLabel = option.label;
          return (
            <Tag key={`option${option.value}`} closable onClose={removeTag(option.value, index)}>
              {tagLabel}
            </Tag>
          );
        })}
      </Space>
    ) : null;

  const textField = (
    <div>
      <Select
        {...props.field}
        mode="multiple"
        showSearch
        value={selectedOptions.map((option) => option.value)}
        onSearch={updateText}
        onChange={handleSelectChange}
        options={filteredOptions}
        style={{ width: "100%" }}
        placeholder={props.field.placeholder}
        filterOption={false}
      />
      {verticalContentMarkup}
    </div>
  );

  const handleSelectChange = useCallback(
    (selectedValues) => {
      const newSelectedOptions = selectedValues
        .map((value) => options.find((option) => option.value === value))
        .filter(Boolean);
      setSelectedOptions(newSelectedOptions);
      setInputValue("");
    },
    [options]
  );

  return <div style={{ height: "auto" }}>{textField}</div>;
};

export default MultiSelect;
